import { useProjectDataStore } from "@state/projectDataStore"
import styled from "styled-components/macro"

type Props = {
  onClick: () => void
}

const BackButton = ({ onClick }: Props) => {
  const { brandingData } = useProjectDataStore((s) => ({
    brandingData: s.brandingData,
  }))
  const colors = brandingData

  return (
    <Wrapper onClick={onClick} colors={colors} className="backButton">
      <img src="assets/icons/back.svg" alt="back" />
    </Wrapper>
  )
}

export default BackButton

const Wrapper = styled.div<{ colors }>`
  position: absolute;
  width: 3.25rem;
  height: 3.25rem;
  z-index: 20;
  margin: 2rem;
  background-color: var(--secondary);
  border-radius: 0px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1rem;
  pointer-events: all;

  &:active {
    opacity: 0.5;
    transform: scale(0.95);
    transition: 0.3s;
  }
`
